import React from "react";
import PropTypes from "prop-types";

import styles from "./Footnote.scss";
import { FootnoteConsumer } from "./FootnoteContext";

// TODO
// eslint-disable-next-line react/prefer-stateless-function
class FootnoteReference extends React.Component {
  static propTypes = {
    number: PropTypes.number.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  };

  static displayName = "Footnotes.Reference";

  render() {
    const { number, children } = this.props;

    return (
      <FootnoteConsumer>
        {(footnotesId) => (
          <span
            className={styles.reference}
            data-telekom-footnote={number}
            aria-describedby={`${footnotesId}-${number}`}
          >
            {children}
          </span>
        )}
      </FootnoteConsumer>
    );
  }
}

export default FootnoteReference;
